import get from 'lodash/get'

export const route = (state) => get(state, ['router', 'location', 'pathname'])
